<template>
  <div id="app">
    <div class="header">
      <div class="header_nav" :class="{'navActive' : scrollFlag}">
        <div class="logo_img">
          <!--<img class="w-100" src="../../../static/img/logo1.png" />-->
          <img class="w-100 header-logo" src="../../../static/img/header_index_logo.png" />
          <img class="w-100 header-logo navActive-logo" src="../../../static/img/header_logo.png" />
        </div>
        <ul class="nav justify-content-center row w-75">
          <li class="nav-item">
            <router-link to="/ESP">
              <a class="nav-link" href="javascript:;">HOME</a>
            </router-link>
          </li>
          <li class="nav-item" @mouseenter="enter()" @click="leave()">
            <router-link to="/about_ESP">
              <a class="nav-link" href="javascript:;">QUIÉNES SOMOS</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{path:'/product_ESP',query:{id:87}}">
              <a class="nav-link" href="javascript:;">PRODUCTOS</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/support_ESP">
              <a class="nav-link" href="javascript:;">SOPORTE</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/download_ESP">
              <a class="nav-link" href="javascript:;">DESCARGAS</a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/contact_ESP">
              <a class="nav-link" href="javascript:;">CONTACTO</a>
            </router-link>
          </li>
          <li class="nav-item">
            <div class="nav-link" href="javascript:;">
              <img src="../../../static/img/EN.png" alt />
              <router-link to="/">EN</router-link>
              <el-divider direction="vertical"></el-divider>
              <img src="../../../static/img/ESP.png" alt />
              <router-link to="/ESP">ESP</router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="header_mini">
      <img src="../../../static/img/header_logo.png" />
      <router-link to="/"><img class="mr-1" src="../../../static/img/EN.png" alt />EN</router-link>
      <div class="header_menu" @click="mini">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="mini_nav" v-show="miniNav">
      <ul>
        <div class="close" @click="cla"><i class="el-icon-close"></i></div>
        <li>
          <router-link to="/ESP">HOME</router-link>
        </li>
        <li>
          <router-link to="/about_ESP">QUIÉNES SOMOS</router-link>
        </li>
        <li>
          <router-link :to="{path:'/product_ESP',query:{id:87}}">PRODUCTOS</router-link>
        </li>
        <li>
          <router-link to="/support_ESP">SOPORTE</router-link>
        </li>
        <li>
          <router-link to="/download_ESP">DESCARGAS</router-link>
        </li>
        <li>
          <router-link to="/contact_ESP">CONTACTO</router-link>
        </li>
        <li>
          <router-link to="/"><img class="mr-1" src="../../../static/img/EN.png" alt />EN</router-link>
        </li>
      </ul>
    </div>
    <div v-show="about" id="aboutus" @mouseenter="enter()" @mouseleave="leave()">
      <div class="about_main row">
        <div class="about_item col-lg-4 col-md-4">
          <router-link class="d-block mt-3" to="/about_ESP">
            <i class="el-icon-arrow-right mr-4"></i>Breve Introducción
          </router-link>
          <router-link class="d-block mt-3" to="/about_ESP1">
            <i class="el-icon-arrow-right mr-4"></i>Nuestra Fábrica
          </router-link>
          <router-link class="d-block mt-3" to="/about_ESP2">
            <i class="el-icon-arrow-right mr-4"></i>Certificados
          </router-link>
          <router-link class="d-block mt-3" to="/about_ESP3">
            <i class="el-icon-arrow-right mr-4"></i>Importancia de la calidad
          </router-link>
          <router-link class="d-block mt-3" to="/about_ESP4">
            <i class="el-icon-arrow-right mr-4"></i>¿Cómo controlar nuestra calidad?
          </router-link>
        </div>
        <div class="col-lg-4 col-md-4">
          <img class="w-100" src="../../img/about/about_us.png" alt />
        </div>
        <div class="col-lg-4 col-md-4 mt-4">
          <p style="font-size:24px;color: #3084c7;">Bienvenidos al sitio web de NAIDA</p>
          <p
            style="font-size:14px;line-height: 30px;"
          >NAIDA es una empresa china especializada en la fabricación y distribución de equipos para el tratamiento de agua.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
body {
  background-color: #fefefe;
  width: 100%;
}
html body #app .header .main {
  width: 100%;
}
.header_nav {
  position: fixed;
  z-index: 9999;
  transition: all 0.3s;
}
#app {
  width: 100%;
  height: 100%;
}
.header-logo{
    width: auto!important;
    height: 85px;
}
.navActive{
  position: fixed;
  background-color: #fff;
}
.navActive .header-logo{
    display: none;
}
.navActive .navActive-logo{
    display: inline-block;
}
.navActive-logo{
    display: none;
}
.navActive a{
    color: gray!important;
}
.row {
  margin-left: 0;
}
.nav-item > a:hover {
  text-decoration: none;
}
.header_mini > div > div {
  width: 30px;
  height: 4px;
  background-color: #3fcbf5;
  margin: 4px;
  display: block;
  text-align: right;
}
.header_mini>img{
  /* width: 150px; */
  height: 50px;
  position: absolute;
  left: 10px;
  top: 5px;
  display: none;
}
.header_mini>a{
  position: absolute;
  top: 15px;
  right: 60px;
  color: gray;
  display: none;
}
.close{
  font-size: 40px;
  color: #fff;
  display: block;
  width: 100%;
  text-align: right;
  margin-right: 20px;
  position: absolute;
  top: 20px;
  right: 10px;
  opacity: 1;
}
.mini_nav {
  width: 100%;
}
.mini_nav >ul{
  width: 100%;
  text-align: center;
  position: fixed;
  left: 0;
  transform-origin: center top;
  height: 100vh;
  overflow: hidden;
  z-index: 99;
  top: 0;
  width: 100vw;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: baseline;
  padding: 25vh 0;
  opacity: 0.8;
  transition: all 0.5s;
  background-color: rgba(0,0,0,.8);
  z-index: 9999;
}
.mini_nav > ul > li {
  list-style: none;
  width: 100%;
}
.mini_nav > ul > li>a{
  color: #fff;
}
.header_mini {
  height: 60px;
  text-align: right;
}
.header_mini > div {
  display: inline-block;
  margin-top: 15px;
  margin-right: 5px;
}
.header_mini {
  display: none;
}
@media screen and (min-width: 1200px) {
  .header_icon {
    display: none;
    z-index: 5;
  }
  .header {
    width: 100%;
    /* height: 1000px; */
    overflow: hidden;
    background: #fff;
    position: relative;
  }
  #aboutus {
    position: fixed;
    z-index: 1000;
    background-color: white;
    width: 100%;
    color: gray;
    top: 100px;
  }
  .about_main {
    width: 80%;
    font-size: 18px;
    margin: 0 auto;
    text-align: left;
  }
  .about_item {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .about_item a:first-child{
      margin-top: 0!important;
  }
  .about_item > a {
    color: gray;
    text-decoration: none;
  }
  .about_item > a:hover {
    color: #3084c7;
  }
  
  .header_nav {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    margin: 0 auto;
    display: flex;
  }
  .nav {
    margin: 0 auto;
  }
  .nav-item {
    margin-right: 4%;
    height: 100px;
    padding: 0;
  }
  .nav-link {
    color: white;
    padding: 0;
    text-decoration: none;
    font-size: 1rem;
  }
  .nav-link a {
    text-decoration: none;
    color: white;
  }
  .log {
    margin-top: 0;
  }
  .logo_img {
    /* background-color: red; */
    z-index: 2;
    width: 20%;
    margin-left: 4%;
  }
  .header_mini {
    display: block;
  }
}
@media screen and (max-width: 1199px) {
  body {
    width: 100%;
  }
  #app {
    width: 100%;
    height: 100%;
  }
  .header {
    display: none;
  }
  .header-bj {
    margin-top: 0px;
  }
  .header_icon {
    display: inline;
    z-index: 5;
  }
  .header {
    width: 100%;
    /* height: 1000px; */
  }
  .header_nav {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    margin: 0 auto;
    display: flex;
  }
  .nav {
    margin: 0 auto;
  }
  .header_mini>a{
    display: block;
  }
  .header_mini>img{
    display: block;
  }
  .nav-item {
    margin-right: 4%;
    height: 100px;
    padding: 0;
  }
  .nav-link {
    color: white;
    padding: 0;
    text-decoration: none;
  }
  .nav-link a {
    text-decoration: none;
  }
  .log {
    margin-top: 0;
  }
  .logo_img {
    /* background-color: red; */
    z-index: 2;
    width: 50%;
    display: none;
  }
  .header_icon {
    width: 100%;
    text-align: right;
  }
  .el-dropdown-link {
    cursor: pointer;
    font-size: 28px;
  }
  .el-icon-arrow-down {
    font-size: 24px;
  }
  .el-item-size {
    font-size: 24px;
  }
  .product_noise > div > img {
    display: none;
  }
  .header_nav {
    position: absolute;
    z-index: 9999;
    background-color: white;
    margin-top: -100px;
  }
  .header_mini {
    display: block;
  }
}
@media screen and (max-width: 576px) {
}
.product_noise {
  width: 40%;
  /* background-color: red; */
  float: left;
  display: flex;
}
.product_noise_img {
  width: 12%;
}
.product_noise_txt {
  float: left;
  background-color: teal;
  width: 88%;
}
.product_noise_txt_span {
  text-align: left;
  display: block;
  color: white;
}
.product1 {
  font-size: 40px;
  color: white;
  /* text-align: center; */
  width: 100%;
  /* text-align: center; */
}
.product2 {
  font-size: 20px;
  color: white;
  width: 100%;
  /* text-align: center; */
}
.product3 {
  font-size: 16px;
  color: white;
  /* text-align: center; */
}
</style>

<script>
import WOW from "wowjs";
export default {
  data() {
    return {
      about: false,
      miniNav: false,
      scrollFlag: false
    };
  },
  methods: {
    enter() {
      this.about = true;
    },
    leave() {
      this.about = false;
    },
    handleScroll() {
      let _this = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      if (scrollTop) {
        _this.scrollFlag = true;
      } else {
        _this.scrollFlag = false;
      }
    },
    mini() {
      if (this.miniNav == false) {
        this.miniNav = true;
      } else if (this.miniNav == true) {
        this.miniNav = false;
      }
    },
    cla(){
      if (this.miniNav == false) {
        this.miniNav = true;
      } else if (this.miniNav == true) {
        this.miniNav = false;
      }
    }
  },
  mounted(){
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/zzj/header_index_ESP.vue